import { put, takeLatest, select } from 'redux-saga/effects';

import reduce from 'lodash/reduce';

import { formatError } from '../../../libs';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import getState from '../../utils/getState';

function* addCreditCard() {
  try {
    const { app, checkout, creditCard } = yield select(getState);
    const totalCreditCards = Object.keys(creditCard.getIn(['creditCards'])).length;
    const maxCreditCards = app.getIn(['config', 'components', 'CreditCard', 'maxCreditCards']);

    if (totalCreditCards < maxCreditCards) {
      const sequencia = Object.keys(creditCard.getIn(['creditCards'])).length + 1;
      const balance = reduce(creditCard.getIn(['creditCards']), (acc, item) => acc + parseFloat(item.valor || 0), 0);
      const valor = Math.abs(creditCard.getIn(['totalValueOrder']) - balance) || 0;
      const totalPending = creditCard.getIn(['totalValueOrder']) - (balance + valor);

      const newCreditCard = {
        sequencia,
        titular: '',
        numero: '',
        validade: '',
        seguranca: '',
        parcela: '',
        valor,
        flag: '',
        installment: { parcelas: !totalCreditCards ? checkout.getIn(['payment', 'parcelas']) : [] },
        updateAt: new Date().getTime(),
        firstLoad: true,
      };

      yield put(CreditCardCreators.addCreditCardSuccess({ totalPending, creditCard: newCreditCard }));
    }
  } catch (error) {
    yield put(CreditCardCreators.addCreditCardError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.ADD_CREDIT_CARD_REQUEST, addCreditCard);
}
